import { isMarketDetailPage, MARKET_DETAIL_SLUGS } from './marketDetailSlugs';
import { isSolutionDetailPage, SOLUTION_DETAIL_SLUGS } from './solutionDetailSlugs';
import { isWealthDetailPage, WEALTH_DETAIL_SLUGS } from './wealthDetailSlugs';
import { isMarketAnalysisPostPage, MARKET_ANALYSIS_POST_DESCRIPTION } from './marketAnalysisPostMetadata';

export const HIDDEN_PAGE_SLUGS = new Set(['global-layout']);

export const SOLUTION_DETAIL_PAGES_PATH = '/dashboard/pages/solution-details';
export const MARKET_DETAIL_PAGES_PATH = '/dashboard/pages/market-details';
export const WEALTH_DETAIL_PAGES_PATH = '/dashboard/pages/wealth-details';
export const MARKET_ANALYSIS_POST_PAGES_PATH = '/dashboard/pages/market-analysis-posts';

export const isHiddenPage = (slug) => HIDDEN_PAGE_SLUGS.has(slug);

export const isDetailPage = (slug) =>
  isSolutionDetailPage(slug) ||
  isMarketDetailPage(slug) ||
  isWealthDetailPage(slug);

export const isGroupedDetailPage = (page) =>
  isDetailPage(page.slug) || isMarketAnalysisPostPage(page.description);

export const partitionPages = (pages) => {
  const visiblePages = pages
    .filter((page) => !isHiddenPage(page.slug))
    .sort((a, b) => a.sortOrder - b.sortOrder);

  const mainPages = visiblePages.filter((page) => !isGroupedDetailPage(page));
  const solutionDetailPages = visiblePages.filter((page) => isSolutionDetailPage(page.slug));
  const marketDetailPages = visiblePages.filter((page) => isMarketDetailPage(page.slug));
  const wealthDetailPages = visiblePages.filter((page) => isWealthDetailPage(page.slug));
  const marketAnalysisPostPages = visiblePages.filter((page) =>
    isMarketAnalysisPostPage(page.description)
  );

  const solutionDetailPagesOrdered = SOLUTION_DETAIL_SLUGS.map(
    (slug) => solutionDetailPages.find((page) => page.slug === slug) || null
  ).filter(Boolean);

  const marketDetailPagesOrdered = MARKET_DETAIL_SLUGS.map(
    (slug) => marketDetailPages.find((page) => page.slug === slug) || null
  ).filter(Boolean);

  const wealthDetailPagesOrdered = WEALTH_DETAIL_SLUGS.map(
    (slug) => wealthDetailPages.find((page) => page.slug === slug) || null
  ).filter(Boolean);

  const marketAnalysisPostPagesOrdered = marketAnalysisPostPages.sort(
    (a, b) => a.sortOrder - b.sortOrder
  );

  return {
    mainPages,
    solutionDetailPages: solutionDetailPagesOrdered,
    marketDetailPages: marketDetailPagesOrdered,
    wealthDetailPages: wealthDetailPagesOrdered,
    marketAnalysisPostPages: marketAnalysisPostPagesOrdered,
  };
};

export const getPageEditorBackPath = (slug, description) => {
  if (isSolutionDetailPage(slug)) {
    return SOLUTION_DETAIL_PAGES_PATH;
  }

  if (isMarketDetailPage(slug)) {
    return MARKET_DETAIL_PAGES_PATH;
  }

  if (isWealthDetailPage(slug)) {
    return WEALTH_DETAIL_PAGES_PATH;
  }

  if (isMarketAnalysisPostPage(description)) {
    return MARKET_ANALYSIS_POST_PAGES_PATH;
  }

  return '/dashboard/pages';
};

export const getPublicPagePath = (slug, description) => {
  if (isMarketAnalysisPostPage(description)) {
    return `/insights/market-analysis/${slug}`;
  }

  if (isSolutionDetailPage(slug)) {
    return `/solutions/${slug}`;
  }

  if (isMarketDetailPage(slug)) {
    return `/markets/${slug}`;
  }

  if (isWealthDetailPage(slug)) {
    return `/wealth/${slug}`;
  }

  if (slug === 'home') {
    return '/';
  }

  if (slug === 'wealth-savings') {
    return '/wealth-savings';
  }

  if (slug === 'infrastructure') {
    return '/technology/infrastructure';
  }

  if (slug === 'platforms') {
    return '/technology/platforms';
  }

  if (slug === 'vps-hosting') {
    return '/technology/vps-hosting';
  }

  if (slug === 'market-analysis') {
    return '/insights/market-analysis';
  }

  if (slug === 'insights') {
    return '/insights';
  }

  if (slug === 'economic-calendar') {
    return '/insights/economic-calendar';
  }

  return `/${slug}`;
};
